export const PoemTile = ({ poem, onOpen }) => (
  <article
    data-testid={`poem-tile-${poem.id}`}
    className="tile"
    onClick={() => onOpen(poem.id)}
  >
    <img className="tile-bg" src={poem.image} alt={poem.title} loading="lazy" />
  </article>
);
